import { getEndpoint } from "@api-routes/endpoint";

const BFF_MS_NAME = "bff";

export const getOrderListRoute = (searchQuery: string) => `${getEndpoint(BFF_MS_NAME)}orders${searchQuery}`;

export const getAccountDetails = () => `${getEndpoint(BFF_MS_NAME)}accounts/details`;

export const getTerminationRequestApiRoute = () => `${getEndpoint(BFF_MS_NAME)}terminations/broadband/requests`;

export const deleteTerminationRequestApiRoute = () => `${getEndpoint(BFF_MS_NAME)}terminations/broadband`;

export const getTerminationDetails = (searchQuery: string) =>
    `${getEndpoint(BFF_MS_NAME)}terminations/broadband/details${searchQuery}`;

export const postTerminationRequest = () => `${getEndpoint(BFF_MS_NAME)}terminations/broadband`;

export const getAddonDetailsRoute = () => `${getEndpoint(BFF_MS_NAME)}addons/broadband/details`;
